import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidEmailWarning extends Violation {
    public constructor(messageParams: { emails: string }) {
        super(ViolationSeverity.Warning, 'business.client.validation.email.message', messageParams);
    }
}
